/**
 * BaggageTable Container Component
 *
 * Smart component that handles:
 * 1. Business logic and data processing via hooks
 * 2. State management and transformations
 * 3. Passes processed data to presentational component
 */

import SimpleBaggageTable from '@/src/components/mobile/srp/SRPFareFamily/FareRulesDrawer/SimpleBaggageTable'
import { useTranslations } from 'next-intl'
import React from 'react'
import BaggageTable from './baggageTable'
import useBaggageData, { type BaggageDataItem } from './useBaggageData'

// Type for raw baggage from API
interface RawBaggageItem {
    baggageType: 'CARRY_ON' | 'CHECK_IN'
    baggageTypeDisplayText: string
    baggageDescription: string | null
    permitted: boolean
    baggageAllowances: Array<{
        unit: string | null
        qty: number
        pieceInfo: number
        description: string
    }>
}

interface BaggageTableContainerProps {
    baggageData: BaggageDataItem[] | any[]
    rawBaggage?: RawBaggageItem[]
}

/**
 * Container component that processes baggage data and passes it to the presentational component
 */
const BaggageTableContainer: React.FC<BaggageTableContainerProps> = ({ baggageData, rawBaggage }) => {
    const t = useTranslations('common')
    // If rawBaggage is provided, use the simple table
    if (rawBaggage && rawBaggage.length > 0) {
        return <SimpleBaggageTable baggage={rawBaggage} />
    }

    // Otherwise use the original complex logic
    const { processedData } = useBaggageData(baggageData as BaggageDataItem[])

    // Pass processed data to presentational component
    return <BaggageTable processedData={processedData} t={t} />
}

export default BaggageTableContainer
export type { BaggageDataItem, PassengerData, PassengerType } from './useBaggageData'
